export default __webpack_public_path__ + "static/media/javasc-typsc.5e5f4337.png";